export const parser_get_company_job_form = (response) => {
  try {
    if (response?.data) {
      response = response.data;
    }
    if (!response) {
      return {};
    }
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const parser_create_send_message = (response) => {
  try {
    if (response?.data) {
      response = response.data;
    }
    if (!response) {
      return {};
    }
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const parser_get_job_messages = (response) => {
  try {
    if (response?.data) {
      response = response.data;
    }
    if (!response) {
      return {};
    }
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const parser_submit_job = (response) => {
  try {
    if (response?.data) {
      response = response.data;
    }
    if (!response) {
      return {};
    }
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const parser_get_job_detail = (response) => {
  try {
    if (response?.data) {
      response = response.data;
    }
    if (!response) {
      return {};
    }
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const parser_update_job = (response) => {
  try {
    if (response?.data) {
      response = response.data;
    }
    if (!response) {
      return {};
    }
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const parser_download_file = (response) => {
  try {
    if (response?.data) {
      response = response.data;
    }
    if (!response) {
      return {};
    }
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const parser_download_zip_file = (response) => {
  try {
    if (response?.data) {
      response = response.data;
    }
    if (!response) {
      return {};
    }
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const parser_job_list = (response) => {
  try {
    if (response?.data) {
      response = response.data;
    }
    if (!response) {
      return {};
    }
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const parser_send_proof = (response) => {
  try {
    if (response?.data) {
      response = response.data;
    }
    if (!response) {
      return {};
    }
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const parser_proof_log_table = (response) => {
  try {
    if (response?.data) {
      response = response.data;
    }
    if (!response) {
      return [];
    }
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const parser_viewproof = (response) => {
  try {
    if (response?.data) {
      response = response.data;
    }
    if (!response) {
      return {};
    }
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const parser_proof_approve = (response) => {
  try {
    if (response?.data) {
      response = response.data;
    }
    if (!response) {
      return {};
    }
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const parser_proof_reject = (response) => {
  try {
    if (response?.data) {
      response = response.data;
    }
    if (!response) {
      return {};
    }
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const parser_add_brand = (response) => {
  try {
    if (response?.data) {
      response = response.data;
    }
    if (!response) {
      return {};
    }
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const parser_get_brand_list = (response) => {
  try {
    if (response?.data) {
      response = response.data;
    }
    if (!Array.isArray(response)) {
      return [];
    }
    // Check for Pydantic/Backend validation error signature in the first item
    if (response.length > 0 && response[0]?.loc && response[0]?.msg && response[0]?.type) {
      return [];
    }
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const parser_get_sidebar_menu = (response) => {
  try {
    if (response?.data) {
      response = response.data;
    }
    if (!response) {
      return [];
    }
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const parser_get_folders = (response) => {
  try {
    if (response?.data) {
      response = response.data;
    }
    if (!Array.isArray(response)) {
      return [];
    }
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const parser_create_folder = (response) => {
  try {
    if (response?.data) {
      response = response.data;
    }
    if (!response) {
      return {};
    }
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const parser_update_folder = (response) => {
  try {
    if (response?.data) {
      response = response.data;
    }
    if (!response) {
      return {};
    }
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const parser_delete_folder = (response) => {
  try {
    if (response?.data) {
      response = response.data;
    }
    return response;
  } catch (error) {
    throw new Error(error);
  }
};